import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from "react-redux";
import swal from "sweetalert";

import ApplicationLayout from "../../../layouts/ApplicationLayout";
import TapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import { DisplayListPagination, DisplaySearchCriteria } from "../../../components/TapUi/index";
import InputItemSearch from '../../includes/ui/InputItemSearch';
import TapSelect from "../../../components/ui/TapSelect";
import { ISC_REPORT_URL } from '../../../services/TapApiUrls';
import TapHelper from '../../../services/TapHelper';
import DownloadFile from "../../../services/DownloadFile";
import Status from '../../../components/ui/Status';
import api from '../../../services/api';
import PageHeader from '../../includes/PageHeader';
import ReportSchedulerModal from '../includes/ReportSchedulerModal';


const InventoryThresholdAnalysis        =   forwardRef((props, ref) => {
    
    const reportKey                 =   'inventory_threshold_report';
    const reportUrl                 =   ISC_REPORT_URL + '/inventory_threshold_analysis';

    const access_token              =   useSelector(state => state.auth.access_token);
    const itemTags                  =   useSelector(state => state.app.item_tags ? state.app.item_tags : []);
    const all_periods               =   useSelector(state => state.app.all_periods ? state.app.all_periods: [] );
    const allWarehouses             =   useSelector(state => state.app.warehouses ? state.app.warehouses : []);
    const reportListing             =   useSelector(state => state.app.report_listing ? state.app.report_listing : []);


    let initFilterFormData          =   {
        show: true,
        per_page: 50,
        form_data_loaded: false,
        loading: false,
        isSearchElement: false,
        search_warehouse_ids: [],
        search_item_ids: [],
        search_item_tags: [],
        search_manufacturer_ids: [],
        search_threshold_status_ids: [],
    }

    let formDataLabel = {
        search_warehouse_ids: 'Warehouse : ',
        search_item_ids: 'Items : ',
        search_item_tags: 'Item Tags : ',
        search_manufacturer_ids: 'Manufacturer : ',
        search_threshold_status_ids: 'Threshold Status : ',
    };


    const isFormLoaded                          =   useRef(false);
    const criteriaRef                           =   useRef();
    const reportSchedulerModalRef               =   useRef();

    const [criteriaHeight, setCriteriaHeight]   =   useState(0)
    const [reportDetail, setreportDetail]       =   useState(null);
    const [filterFormData, setFilterFormData]   =   useState(initFilterFormData)
    const [searchedElems, setSearchedElems]     =   useState([]);
    
    const [formData, setFormData] = useState({
        allWarehouses: [],
        allItemTags: [],
        allStatusOptions: [],
        searchedItem: [],
        allmanufacturer:[]
    })
    const [onScreenData, setOnScreenData] = useState({
        loading: false,
        show: false,
        reportDownloadBtn: false,
        reportDownloading: false,
        data: [],
        meta: null,
        page: 1
    });

    

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };
     useEffect(() => {
        setreportDetail(reportListing.find(d => d.key == reportKey));
    }, [reportListing]);

    useEffect(() => {
        updateCriteriaHeight();

        if (!isFormLoaded.current) {
            loadFormData();
            isFormLoaded.current = true;
        }
    }, []);

    useEffect(() => {
        if (filterFormData.isSearchElement) {
            loadListData()
        }
    }, [filterFormData.isSearchElement])

    useEffect(() => {
        if (filterFormData.form_data_loaded &&
            (filterFormData.search_threshold_status_ids.length > 0 || filterFormData.search_warehouse_ids.length > 0)) {
            const { search } = props.location;
            const searchParams = new URLSearchParams(search);
            const statusId = searchParams.get('status_id');
            const warehouseIds = searchParams.getAll('warehouse_ids[]');

            if ((statusId && filterFormData.search_threshold_status_ids.length > 0) ||
                (warehouseIds && filterFormData.search_warehouse_ids.length > 0)) {
                reportFilterFormSubmit();
            }
        }
    }, [filterFormData.form_data_loaded]);

    const loadFormData = () => {
        setFilterFormData(pre => ({ ...pre, form_data_loaded: false }));

        setFormData(pre => ({
            ...pre,
            allItemTags         :   itemTags.length > 0
                                        ? itemTags.map((s) => { return { value: s.id, label: s.name }; }) 
                                        : [],
            allWarehouses       :   allWarehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` } }),
        }))

        api.server2Api.get(reportUrl, {params : { action: "formData" }, headers : { 'Authorization': 'Bearer ' + access_token}  })
        .then((response) => {
            if (response.data) {
                let statusOptions = response.data.status.map((status) => ({
                    value: status.key,
                    label: status.status
                }));
                let manufacturerData = response.data.manufacturers.map((i) => ({
                    value: i.id, 
                    id: i.id,     
                    label: i.name,
                    name: i.name
                }));


                setFormData(pre => ({ ...pre, allStatusOptions: statusOptions, allmanufacturer: manufacturerData }));

                const { search } = props.location;
                const searchParams = new URLSearchParams(search);
                const statusId = searchParams.get('status_id');
                const warehouseIds = searchParams.getAll('warehouse_ids[]');


                if (statusId) {
                    let status = statusOptions.find(us => us.value == statusId);
                    let warehouse = allWarehouses.find(us => us.id == warehouseIds);

                    setFilterFormData(prev => ({
                        ...prev,
                        search_threshold_status_ids: status ? [status.value] : [],
                        search_warehouse_ids: warehouse ? [warehouse?.id] : [],
                    }))
                }
            }
        }).catch((error) => {}).finally(() => {
            setFilterFormData(pre => ({ ...pre, form_data_loaded: true }));
        });
    }

    const loadListData = (page = 1) => {
        setOnScreenData(pre => ({ ...pre, loading: true }));
        setFilterFormData(pre => ({ ...pre, isSearchElement: false }));
        let params = {
            action: 'data',
            page,
            ...TapHelper.pick(filterFormData, ["search_warehouse_ids", "search_item_ids", "search_item_tags", "search_manufacturer_ids", "search_threshold_status_ids"])
        };

        HttpAPICall.withAthorization('GET', reportUrl, access_token, params, null, (resp) => {
            const respData = resp.data;
            let meta = TapHelper.pick(respData, ['from', 'to', 'total', 'last_page', 'per_page', 'current_page']);
            setOnScreenData(pre => ({
                ...pre,
                reportDownloadBtn: true,
                data: respData.data,
                meta
            }))
        }).then(() => setOnScreenData(pre => ({ ...pre, loading: false })));
    }

    const closeReport                   = () =>  props.history.push('/report');

    const toggleFilterForm = (show) => {
        setFilterFormData(pd => ({ ...pd, show: show }))
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }

    const handleChangeOption = (selectedOption, optionName) => {
        let data = (Array.isArray(selectedOption))
            ? selectedOption.map(op => op.value)
            : selectedOption
                ? selectedOption.value
                : ""

        setFilterFormData(pre => ({ ...pre, [optionName]: data }))
    }

    const reportFilterFormSubmit = (e) => {
        e && e.preventDefault()

        let runApi = true;

        if (runApi) {
            toggleFilterForm(false);
            let serachFormKeys = Object.keys(filterFormData);
            let searchedElems = [];
            let itemSearchParams = {};
            serachFormKeys.map((key) => {
                let label = formDataLabel[key];
                let value = filterFormData[key];
                if (value && value.toString().length > 0) {
                    itemSearchParams[key] = value;
                    if (label) {
                        let show_val = value;
                        if (key == 'search_warehouse_ids') {
                            show_val = formData.allWarehouses.filter((s) => filterFormData.search_warehouse_ids.includes(s.value)).map(s => s.label);
                        }
                        if (key == 'search_item_ids') {
                            show_val = formData.searchedItem ? formData.searchedItem.map(s => s.display_label).join(', ') : '';
                        }
                        if (key == 'search_item_tags') {
                            show_val = formData.allItemTags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if (key == 'search_manufacturer_ids') {
                            show_val = formData?.allmanufacturer.filter((s) =>
                                value.includes(s.value)
                            ).map(s => s.label).join(', ');
                        }
                        if (key == 'search_threshold_status_ids') {
                            show_val = formData.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        searchedElems.push(label + `<b>${show_val}</b>`);
                    }
                }
            })

            setFilterFormData(pre => ({ ...pre, isSearchElement: true }))
            setSearchedElems(searchedElems);
            setOnScreenData(pre => ({ ...pre, show: true }))
        }
    }

    const reportScheduleHandler         =   () => {
        if (reportSchedulerModalRef.current) {
            reportSchedulerModalRef.current.initModalHandler(reportKey);
        }
    }

    let filteredData                    =   TapHelper.pick(filterFormData, ["search_warehouse_ids", "search_item_ids", "search_item_tags", "search_manufacturer_ids", "search_threshold_status_ids"]);

    const downloadReport = () => {
        setOnScreenData(pre => ({...pre,  reportDownloading: true}));
        let params = {
            action: 'download',
            ...filteredData
        };
        HttpAPICall.withAthorization('GET', reportUrl, access_token, params, {}, (response) => { DownloadFile.file(response.data.file_path, response.data.msg, response.data.navigation, props) }).then(() => {
            setOnScreenData(pre => ({
                ...pre,
                reportDownloading: false
            }))
        });
    }

    const reportFilterFormJsx = () => {
        return (
            <>
                {!filterFormData.form_data_loaded ? <Loader /> : <>
                    <form onSubmit={reportFilterFormSubmit} className={['p-3', 'filter_form'].join(' ')}>
                        <div className="row my-3">
                            <label className="col-sm-3 col-form-label text-end">Item</label>
                            <div className="col-sm-6">
                                <InputItemSearch
                                    placeholder="Search Item"
                                    isMulti={true}
                                    changeEvent={(selectedOption) => {
                                        handleChangeOption(selectedOption, 'search_item_ids');
                                        setFormData(pre => ({ ...pre, searchedItem: selectedOption }))
                                    }}
                                    value={formData.searchedItem.length > 0 ? formData.searchedItem.map(a => { a.label = a.display_label; return a; }) : []}
                                />
                            </div>
                        </div>
                        <div className="row my-3 align-items-center">
                            <label className="col-sm-3 col-form-label text-end">Item Tags</label>
                            <div className="col-sm-6">
                                <TapSelect
                                    options={formData.allItemTags}
                                    changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_item_tags')}
                                    value={formData.allItemTags.filter(u => filterFormData.search_item_tags.includes(u.value))}
                                    isSearchable={true}
                                    isMulti={true}
                                    isClearable={true}
                                    placeholder="Select Item Tags"
                                />
                            </div>
                        </div>
                        <div className="row my-3 align-items-center">
                            <label className="col-sm-3 col-form-label text-end">Warehouse</label>
                            <div className="col-sm-6">
                                <TapSelect
                                    options={formData.allWarehouses}
                                    changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_warehouse_ids')}
                                    value={formData.allWarehouses.filter(u => filterFormData.search_warehouse_ids.includes(u.value))}
                                    isSearchable={true}
                                    isMulti={true}
                                    isClearable={true}
                                    placeholder="Select Warehouses"
                                />
                            </div>
                        </div>
                        <div className="row my-3">
                            <label className="col-sm-3 col-form-label text-end">Manufacturer</label>
                            <div className="col-sm-6">
                                <TapSelect
                                    options={formData?.allmanufacturer}
                                    changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_manufacturer_ids')}
                                    isSearchable={true}
                                    isClearable={true}
                                    isMulti={true}
                                    value={formData?.allmanufacturer.filter(s =>
                                        filterFormData.search_manufacturer_ids.includes(s.value)
                                    )}
                                    placeholder="Select Manufacturer"
                                />
                            </div>
                        </div>
                        <div className="row my-3">
                            <label className="col-sm-3 col-form-label text-end">Status</label>
                            <div className="col-sm-6">
                                <TapSelect
                                    options={formData.allStatusOptions}
                                    changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_threshold_status_ids')}
                                    isSearchable={true}
                                    isClearable={true}
                                    isMulti={true}
                                    value={formData.allStatusOptions.filter(s => filterFormData.search_threshold_status_ids.includes(s.value))}
                                    placeholder="Select Status"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="pb-3 col-9 text-end">
                                <button type="submit" disabled={false} className="btn btn-primary px-4">Show Report</button>
                            </div>
                            <hr />
                        </div>
                    </form>
                </>}
            </>
        );
    }

    const listData                          =   () =>   {
        return <>
            <div ref={criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
                <DisplaySearchCriteria searchedElems={searchedElems} />
            </div>
            <table className="table table-sm table-bordered align-middle bg-white">
                <thead className="align-middle table-secondary" style={{
                    top: `${criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr>
                        <th className='text-center' style={{ width: "5%" }}>#</th>
                        <th className="text-center" style={{ width: "20%" }}>Item Name</th>
                        <th className="text-center" style={{ width: "10%" }}>Item Number</th>
                        <th className="text-center" style={{ width: "10%" }}>Manufacturer</th>
                        <th className="text-center" style={{ width: "15%" }}>Warehouse</th>
                        <th className="text-center" style={{ width: "10%" }}>Total Stock (Qty)</th>
                        <th className="text-center" style={{ width: "10%" }}>Min Level</th>
                        <th className="text-center" style={{ width: "10%" }}>Max Level</th>
                        <th className="text-center" style={{ width: "10%" }}>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        onScreenData.loading
                            ? <tr className='text-center'><td colSpan={10}><Loader /></td></tr>
                            :
                            onScreenData.data.length > 0
                                ?
                                onScreenData.data.map((item, index) => (
                                    <tr key={index} >
                                        <td className='text-center'>{(onScreenData.meta?.from || 0) + index}</td>
                                        <td>{item.name || "-"} ({item.item_code || "-"})</td>
                                        <td>{item.item_number || '-'}</td>
                                        <td>{item?.manufacturer_name || '-'}</td>
                                        <td>{item.warehouse_name || "-"} ({item.warehouse_code || "-"})</td>
                                        <td className='text-end fw-bold'>{item.total_qty || '-'}</td>
                                        <td className='text-end'>{item.min_inventory_level || '-'}</td>
                                        <td className='text-end'>{item.max_inventory_level || '-'}</td>
                                        <td>
                                            <Status color={item?.status?.status_color_code}>{item.status?.status_text}</Status>
                                        </td>
                                    </tr>
                                ))
                                : <tr className='text-center'><td colSpan={10}>No Record Found</td></tr>
                    }
                </tbody>
            </table>
            <DisplayListPagination meta={onScreenData.meta} onPageChange={(e) => loadListData(e.selected + 1)} keyName="Inventory Threshold Analysis" />
        </>
    }

    const topRightHeaderJsx                 =   () =>   {
        return <div className="text-end">
            <button type="button" onClick={() => toggleFilterForm(!filterFormData.show)} className="btn btn-secondary">Change Filter</button>
            {onScreenData.reportDownloadBtn && <button disabled={onScreenData.reportDownloading} type="button" className="btn btn-secondary" onClick={downloadReport}>
                <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                {onScreenData.reportDownloading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />) : null}
            </button>}
            <button type="button" onClick={reportScheduleHandler} className="btn btn-secondary">Schedule Report</button>
            <button type="button" className="btn btn-secondary" onClick={closeReport}>
                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close Report" />
            </button>
        </div>
    }

    return (
        <ApplicationLayout>
            <PageHeader title={reportDetail?.name} name={reportDetail?.name} rightTopHeadingJsx={topRightHeaderJsx()}/>
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        <div className={["bg-white", filterFormData.show ? 'tbShow' : 'tbHide'].join(" ")}>
                            {filterFormData.loading ? <Loader /> : reportFilterFormJsx()}
                        </div>
                        {onScreenData.show && listData()}
                    </div>
                </div>
            </div>
            <ReportSchedulerModal ref={reportSchedulerModalRef} searchedElems={searchedElems} filteredData={filteredData} />
        </ApplicationLayout>
    )
});


export default InventoryThresholdAnalysis;